export default {
    en: {
        pageTitle: "Multiples languages available",
        pageTitleThemes: "Two themes available",
        pageTitleBrowser: "Can used in many browsers",
        english: "English",
        spanish: "Spanish",
        creole: "Creole"
    },
    es: {
        pageTitle: "Múltiples idiomas disponibles",
        pageTitleThemes: "Dos temas disponibles",
        pageTitleBrowser: "Puede usarse en muchos navegadores",
        english: "Inglés",
        spanish: "Español",
        creole: "Criollo"
    },
    ko: {
        pageTitle: "Miltip lang disponib",
        pageTitleThemes: "De tèm ki disponib",
        pageTitleBrowser: "Èske yo ka itilize nan anpil navigatè",
        english: "Angle",
        spanish: "Panyòl",
        creole: "kreol"
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/language/language.language.js
// module id = 630
// module chunks = 0